import { styled } from "@mui/material/styles";
import {
    Button,
    ButtonProps,
    InternalStandardProps,
} from "@mui/material";

export interface AppButtonProps extends InternalStandardProps<ButtonProps> {
    buttonVariant?:
        | "primary-filled"
        | "grey-outlined"
        | "grey-text"
        | "disabled-outlined";
    rounded?: boolean;
}

const StyledButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== "buttonVariant" && prop !== "rounded",
})<AppButtonProps>(({ theme, buttonVariant, rounded }) => ({
    textTransform: "none",
    background: theme.palette.primary.main,
    color: theme.colors?.white,
    ...(buttonVariant === "primary-filled" && {
        background: theme.palette.primary.main,
        color: theme.colors?.white,
        "&:hover": {
            background: theme.palette.primary.dark,
            color: theme.colors?.white,
        },
        "&:active": {
            background: theme.palette.primary.main,
            color: theme.colors?.white,
        },
        "&:disabled": {
            background: theme.palette.secondary.main,
        },
    }),
    ...(buttonVariant === "grey-outlined" && {
        background: "transparent",
        boxShadow: "none",
        color: theme.palette.grey.A100,
        border: `2px solid ${theme.palette.grey.A100}`,
        "&:hover": {
            background: "transparent",
            boxShadow: "none",
        },
        "&:disabled": {
            background: "transparent",
            color: theme.palette.grey[300],
        },
    }),
    ...(buttonVariant === "disabled-outlined" && {
        background: "transparent",
        boxShadow: "none",
        color: theme.palette.grey[300],
        border: `2px solid ${theme.palette.grey[300]}`,
        "&:hover": {
            background: "transparent",
            boxShadow: "none",
        },
        "&:disabled": {
            background: "transparent",
            color: theme.palette.grey[300],
        },
    }),
    ...(buttonVariant === "grey-text" && {
        background: "transparent",
        boxShadow: "none",
        color: theme.palette.grey.A100,
        "&:hover": {
            background: "transparent",
            boxShadow: "none",
        },
        "&:disabled": {
            background: "transparent",
            color: theme.palette.grey[300],
        },
    }),
    ...(rounded && {
        borderRadius: theme.spacing(3),
        padding: theme.spacing(1, 3),
    }),
}));

export const AppButton = (props: AppButtonProps) => {
    const {
        buttonVariant,
        variant = "contained",
        rounded,
        ...rest
    } = props;

    return (
        <StyledButton
            {...rest}
            variant={variant}
            buttonVariant={buttonVariant}
            rounded={rounded}
        />
    );
};
